import { useState, useCallback } from "react";
import { apiFetch } from "@/lib/api-client";

interface CentralizeEntry {
  entryId: string;
  expenseOrRevenueAccountId: string;
  saveContactMapping?: boolean;
}

interface CentralizeResult {
  centralized: number;
  journalEntryIds: string[];
  contactsCreated: number;
  contactsUpdated: number;
}

export function useCentralize() {
  const [isCentralizing, setIsCentralizing] = useState(false);

  const centralize = useCallback(
    async (entries: CentralizeEntry[], createAsDraft?: boolean): Promise<CentralizeResult> => {
      setIsCentralizing(true);
      try {
        return await apiFetch.post<CentralizeResult>("/api/rcv/centralize", {
          entries,
          createAsDraft,
        });
      } finally {
        setIsCentralizing(false);
      }
    },
    [],
  );

  return { centralize, isCentralizing };
}
